import { render, staticRenderFns } from "./sub-vendor-signup.vue?vue&type=template&id=254aa3ae&"
import script from "./sub-vendor-signup.vue?vue&type=script&lang=js&"
export * from "./sub-vendor-signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports